import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'login/doLogin',
    method: 'post',
    data
  })
}

export function getUserList(params) {
  return request({
    url: 'user/userList',
    method: 'get',
    params
  })
}

export function toExamine(data) {
  return request({
    url: 'user/toExamine',
    method: 'post',
    data
  })
}

export function updateUser(id, data) {
  return request({
    url: 'user/' + id,
    method: 'put',
    data
  })
}

export function deleteUser(id) {
  return request({
    url: 'user/' + id,
    method: 'delete'
  })
}

export function resetUserPassword(id) {
  return request({
    url: 'user/' + id + '/reset-password',
    method: 'post'
  })
}

export function verifyUser(data) {
  return request({
    url: '/user/toExamine',
    method: 'post',
    data
  })
} 
export function getUserInfo() {
  return request({
    url: '/user/userInfo',
    method: 'get'
  })
}

